import { Component, EventEmitter,Output } from '@angular/core';

@Component({
  selector: 'app-sidebar-minimizer',
  templateUrl: './app-sidebar-minimizer.component.html'
})
export class AppSidebarMinimizerComponent {

  @Output()
  propagar = new EventEmitter<boolean>();
  isMinimizado:boolean=false;

  constructor(){
    this.onPropagar();
  }
  
  isMinimizar(){
    this.isMinimizado = !this.isMinimizado;
    this.onPropagar();
    console.log(this.isMinimizado);
  }

  onPropagar(){
    this.propagar.emit(this.isMinimizado);
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/app-sidebar-minimizer/app-sidebar-minimizer.component.ts